<template>
  <div>

    <div class="pointRechargeWrap">
      <div class="cancel" @click="cancel">x</div>
      <h1 class="pointRechargeTitle">积分充值</h1>
      <div class="pointRechargeType">
        <ul>
          <li class="pointRechItem" v-for="item in pointRechargeList" :key="item.type"
            :class="{ 'actItem': typeNum === item.type }" @click="changeItem(item.type, item.price)">
            <div class="pointNum">{{ item.points + item.givePoints }}积分</div>
            <div class="pricePoint">¥ {{ item.price }}</div>
            <div class="descPoint">包含赠送{{ item.givePoints }}积分</div>
            <img v-if="typeNum === item.type" src="@/assets/member/gouxuan.png" alt="">
          </li>
        </ul>
        <!-- 自定义充值积分 -->
        <div class="customRech" @click="addActBg(4)" :class="{ 'actItem': typeNum === 4 }">
          <div class="customRechTitle">自定义充值</div>
          <div class="pointNum">
            <input @input="handleIpt" @change="handlerchange" v-model.number="pointNum" type=" ">积分
          </div>
          <div class="pricePoint">¥ {{ moneypoint }}</div>
          <div class="descPoint">自定义充值不赠送积分</div>
          <img v-if="typeNum === 4" src="@/assets/member/gouxuan.png" alt="">
        </div>
      </div>
      <div class="pointPayMethods">
        <div class="leftInstr">
          <h1>充值说明</h1>
          <p>1.充值积分比例为<span style="color: #f00;">1元=10积分，10元起充</span> 。</p>
          <p>2.充值积分仅可购买积分模型素材，不可提现，不可转换为其他货币。</p>
          <p>3.积分成功充值后，不支持退换，请理性消费，谨慎购买。</p>
          <p>4.自定义充值积分不额外赠送积分。</p>
          <p>5.充值积分不支持搜币、搜点等方式。</p>
          <p>6.积分充值目前支持微信、支付宝，暂不支持PayPal。</p>
          <p>7.开通会员享更多权益。</p>
        </div>
        <div class="middleCon">
          <h1 class="methodTxt">付款方式</h1>
          <ul class="payMethods">
            <li @click="item.type !== 3 && payToggle(item.type)" v-for="item in payMethod" :key="item.type"
              :class="{ 'actBgColor': payNum === item.type }">
              <img v-if="item.type === 1" :src="item.url" alt="">
              <img v-else-if="item.type === 2" :src="item.url" alt="">
              <img class="payPalImg" v-else-if="item.type === 3" :src="item.url" alt="">
              <div v-if="item.type === 3" class="rightTop">暂未开通</div>
              <span v-if="item.name">{{ item.name }}</span>
              <div v-if="item.type !== 3 && payNum === item.type" class="gouxuan"></div>
            </li>
          </ul>
        </div>
        <div class="rightQrcode">
          <div v-if="payNum === 1" style="margin-top: 30px; padding-left: 25px" class="qrcodePic" id="wxQrcodeImg"
            ref="wxQrcodeImg"></div>
          <div v-else-if="payNum === 2" class="qrcodePic"
            style="margin-top: 30px; padding-left: 25px; margin-bottom: 0px; width: 150px; overflow: hidden;"
            id="zxbIframe" ref="zxbIframe">
            <iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="120" height="120"
              style="overflow: hidden;" id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe">
            </iframe>
          </div>
          <div class="price">
            <span class="totalPrice" v-if="typeNum !== 4">¥{{ vipPrice }}</span>
            <span class="totalPrice" v-else-if="typeNum === 4">¥{{ moneypoint }}</span>
            <span class="qrcodePay">(扫码支付)</span>
          </div>
          <div class="delayTime">若二维码过期失效，请刷新页面重新进入支付！</div>
        </div>
      </div>
      <div v-clickoutside="handleClickontactUs" class="code" v-if="ishidden">
        <img src="@/assets/link.png" alt="">
        <p>
          扫码联系客服
        </p>
      </div>
      <div class="contactCust">充值遇到问题？<a @click="contactCustFn">联系客服</a></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QRCode from "qrcodejs2";
import { decode } from 'js-base64';
import { pointsPriQueryApi } from '@/api/membership.js'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { wxPointsQrcodeApi, queryPointsWxPayStatus, zfbPointsQrcodeApi, queryZfbPointsPayStatus } from '@/api/membership.js'

export default {
  directives: { Clickoutside },
  name: "pointRecharge",
  data () {
    return {
      pointRechargeList: [],
      payMethod: [  // 支付方式tab
        {
          type: 1,
          url: require('@/assets/wechat.png'),
          name: '微信支付'
        },
        {
          type: 2,
          url: require('@/assets/alipay_icon.png'),
          name: '支付宝'
        },
        {
          type: 3,
          url: require('@/assets/member/Paypal2.png'),
        },
      ],
      typeNum: 2,
      customPrice: 10, // 自定义价格
      pointNum: 100, // 自定义积分数量
      typeData: null, // 自定义
      payNum: 1, // 支付方式高亮
      vipPrice: 500,
      ishidden: false,
      amount: null,
      typeMember: null,
      isVisible: false
    }
  },
  beforeDestroy () {
    clearInterval(this.wxtimer); // 清除定时器
    clearInterval(this.zfbtimer); // 清除定时器
  },
  mounted () {
    this.pointsPriQueryFn()
    this.amount = 500
    this.typeMember = 2
    this.wxPay()
    this.zfbPay()
  },
  watch: {
    pointNum: {
      handler (newval) {
        this.amount = Number((newval * 0.1).toFixed(1))
        this.wxPay()
        this.zfbPay()
      }
    }
  },
  computed: {
    ...mapGetters(['GET_USER_INFO']),
    // 生成aid
    isAuthor () {
      if (!this.GET_USER_INFO.token) {
        return false
      } else {
        let arr = this.GET_USER_INFO.token.split('.')
        let userInfo = JSON.parse(decode(arr[1]))
        return userInfo.aId
      }
    },
    moneypoint () {
      if (this.pointNum < 100) {
        return 10
      } else {
        return (this.pointNum * 0.1).toFixed(1)
      }

    }
  },
  methods: {
    handlerchange (val) {
      if (val.target.value < 100) {
        this.pointNum = 100
      }
    },
    handleIpt (val) {
      if (Number(val.target.value) >= 999999) {
        this.pointNum = 999999
      }
    },
    changeItem (type, price) {
      this.typeNum = type;
      this.vipPrice = price;
      this.amount = price;
      this.typeMember = type
      this.wxPay()
      this.zfbPay()
    },
    addActBg (n) {
      this.typeNum = n;
      this.typeMember = n
      this.amount = Number((this.pointNum * 0.1).toFixed(1))
      this.wxPay()
      this.zfbPay()
    },
    /**
     * @支付方式切换
     */
    payToggle (type) {
      this.payNum = type;
      if (type === 1) { // 微信
        let zxbIframeDiv = document.getElementById("zxbIframe");
        zxbIframeDiv.innerHTML = "";
        this.wxPay()
      } else if (type === 2) {
        this.zfbPay()
      }
    },
    /**
     * @desc 积分价格查询
     */
    async pointsPriQueryFn () {
      const res = await pointsPriQueryApi()
      if (res.code === 200) {
        this.pointRechargeList = res.data
      }
    },
    /**
     * @desc 联系客服
     */
    contactCustFn () {
      this.ishidden = true
    },
    handleClickontactUs () {
      this.ishidden = false
    },

    qrcode (url, name) {
      // 前端根据 URL 生成支付二维码
      return new QRCode(name, {
        width: 120,
        height: 120,
        text: url,
        colorDark: "#000",
        colorLight: "#fff",
      });
    },
    /**
     * @desc 查询微信支付状态
     * @param {*} sn 
     */
    handleQueryWxPayStatus (sn) {
      let that = this;
      queryPointsWxPayStatus({ outTradeNo: sn }).then((res) => {
        if (res.data.trade_state == "SUCCESS") {
          // 当查询到支付成功时
          // 积分充值组件消失 如果充值成功，弹出充值成功组件
          this.$emit('hiddenPoints', false) // 积分充值弹窗消失
          this.$emit('isBuySuccess', true) // 充值成功的提示弹窗-显示
          this.$emit('changeMemType', 4)
          clearInterval(that.wxtimer); // 清除定时器
        }
      });
    },

    /**
     * @desc 生成微信二维码
     */
    async wxPay () {
      clearInterval(this.wxtimer); // 清除定时器
      const params = {
        amount: this.amount,
        aid: this.isAuthor,
        type: this.typeMember
      };
      await wxPointsQrcodeApi(params).then((res) => {
        this.$refs.wxQrcodeImg.innerText = "";
        // 根据这个值生成相对应的支付二维码
        this.qrcode(res.data.codeUrl, "wxQrcodeImg");
        if (res.data.outTradeNo) {
          this.wxtimer = setInterval(() => {
            // 通过定时器每间隔一会去请求查询支付状态
            this.handleQueryWxPayStatus(res.data.outTradeNo);
          }, 1000);
        }
      });
    },

    /**
      * @desc 查询支付宝支付状态
      * @param {*} sn 
      */
    handleQueryZfbPayStatus (sn) {
      let that = this;
      // 查询支付宝支付状态
      queryZfbPointsPayStatus({ outTradeNo: sn }).then(res => {

        if (res.data.trade_state == "SUCCESS") {
          // 当查询到支付成功时
          this.$emit('hiddenPoints', false) // 积分充值弹窗消失
          this.$emit('isBuySuccess', true) // 充值成功的提示弹窗-显示
          this.$emit('changeMemType', 4)
          clearInterval(that.zfbtimer); // 清除定时器
        }
      });
    },

    /**
     * @desc 生成支付宝二维码
    */
    async zfbPay () {
      clearInterval(this.zfbtimer); // 清除定时器
      const params = {
        amount: this.amount,
        aid: this.isAuthor,
        type: this.typeMember
      };

      await zfbPointsQrcodeApi(params).then(res => {

        let zxbIframeDiv = document.getElementById("zxbIframe");
        zxbIframeDiv.innerHTML = "";
        zxbIframeDiv.innerHTML =
          '<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="300" height="120" style="overflow: hidden;" id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe"></iframe>';
        let zxbIframe = document["zxbIframe"]
          ? document["zxbIframe"]
          : window.frames["zxbIframe"];
        zxbIframe.document.write(res.data.body);

        if (res.data.outTradeNo) {
          this.zfbtimer = setInterval(() => {
            // 通过定时器每间隔一会去请求查询支付状态
            this.handleQueryZfbPayStatus(res.data.outTradeNo);
          }, 1000);
        }
      });
    },
    cancel () {
      this.$emit('hiddenPoints', false)
    }
  }
}
</script>

<style lang="less" scoped>
.pointRechargeWrap {
  width: 920px;
  height: 600px;
  background-color: #fff;
  border: 1px solid #e0b58c;
  border-radius: 10px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 9999;
  user-select: none;

  .pointRechargeTitle {
    width: 100%;
    height: 70px;
    background: linear-gradient(to right, #292b3c, rgba(41, 43, 60, 0.5));
    color: #fff;
    font-size: 30px;
    font-weight: 700;
    line-height: 70px;
    border-radius: 10px 10px 0 0;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .pointRechargeType {
    width: 870px;
    height: 200px;
    margin: 20px auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    ul {
      display: flex;
      flex-direction: row;

      .pointRechItem {
        width: 200px;
        height: 200px;
        background-color: #fff;
        border-radius: 15px;
        border: 1px solid #e0b58c;
        margin-right: 21px;
        cursor: pointer;

        .pointNum {
          width: 160px;
          border-bottom: 2px solid #ccc;
          font-size: 26px;
          line-height: 50px;
          font-weight: 500;
          text-align: center;
          margin-left: 20px;
          margin-top: 50px;
        }

        .pricePoint {
          margin-top: 10px;
          font-size: 26px;
          font-weight: 500;
          color: #fa540d;
          margin-left: 55px;
        }

        .descPoint {
          font-size: 12px;
          margin: 10px 0 0 50px;
          font-weight: 500;
        }
      }

      .actItem {
        background-color: #fef1e3;
        position: relative;

        img {
          width: 20%;
          position: absolute;
          right: -1px;
          bottom: -1px;
          -webkit-user-drag: none;
        }
      }
    }

    .customRech {
      width: 200px;
      height: 200px;
      background-color: #fff;
      border-radius: 10px;
      border: 1px solid #e0b58c;

      .customRechTitle {
        width: 100%;
        height: 35px;
        background: linear-gradient(to right, #292b3c, rgba(41, 43, 60, 0.5));
        color: #fff;
        font-size: 14px;
        line-height: 35px;
        border-radius: 10px 10px 0 0;
        padding-left: 10px;
        box-sizing: border-box;
      }

      .pointNum {
        width: 160px;
        border-bottom: 2px solid #ccc;
        font-size: 26px;
        font-weight: 500;
        text-align: center;
        margin-left: 20px;
        margin-top: 30px;
        line-height: 50px;

        input {
          width: 80px;
          height: 30px;
          border: none;
        }
      }

      .pricePoint {
        margin-top: 10px;
        font-size: 26px;
        font-weight: 500;
        color: #fa540d;
        text-align: center;
      }

      .descPoint {
        font-size: 12px;
        margin: 10px 0 0 50px;
        font-weight: 500;
      }
    }

    .actItem {
      background-color: #fef1e3;
      position: relative;

      img {
        width: 20%;
        position: absolute;
        right: -1px;
        bottom: -1px;
        -webkit-user-drag: none;
      }
    }
  }

  .pointPayMethods {
    display: flex;
    flex-direction: row;
    width: 870px;
    height: 250px;
    border: 1px solid #e0b58c;
    border-radius: 10px;
    margin: auto;

    .leftInstr {
      width: 600px;
      height: 100%;
      text-align: center;

      h1 {
        font-size: 26px;
        font-weight: 500;
        margin-top: 10px;
        line-height: 50px;
      }

      p {
        text-align: start;
        font-size: 14px;
        line-height: 24px;
        color: #383838;
        white-space: nowrap;
        margin-left: 20px;
        font-weight: 600;
      }
    }

    .middleCon {
      position: relative;
      left: -120px;

      .methodTxt {
        font-size: 26px;
        font-weight: 500;
        margin-top: 20px;
      }

      .payMethods {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        user-select: none;

        li {
          width: 150px;
          height: 42px;
          border: 2px solid #e0b58c;
          border-radius: 10px;
          line-height: 42px;
          position: relative;
          margin-top: 10px;
          cursor: pointer;

          img {
            width: 20%;
            margin-left: 12px;
            margin-top: 5px;
            margin-right: 10px;
            -webkit-user-drag: none;
          }

          .payPalImg {
            width: 70%;
            margin-top: 9px;
            margin-left: 14px;
          }

          .rightTop {
            width: 58px;
            height: 17px;
            background-color: #e0b58c;
            position: absolute;
            right: -6px;
            bottom: 27px;
            font-size: 12px;
            scale: 0.8;
            border-radius: 0 10px 0 10px;
            text-align: center;
            line-height: 17px;
          }

          span {
            display: inline-block;
            transform: translateY(-7px);
            font-size: 20px;
          }

          .gouxuan {
            width: 50px;
            height: 50px;
            position: absolute;
            right: -1px;
            bottom: -1px;
            background-image: url("../../assets/member/gouxuan.png");
            background-repeat: no-repeat;
            background-size: 50% 50%;
            background-position: 100% 100%;
          }
        }

        .actBgColor {
          background-color: #fef1e3;
        }
      }
    }

    .rightQrcode {
      position: relative;

      .qrcodePic {
        position: absolute;
        left: -100px;
      }

      .price {
        width: 200px;
        position: absolute;
        top: 160px;
        left: -75px;

        .totalPrice {
          color: #ff4f00;
          font-size: 24px;
          font-weight: 500;
        }

        .qrcodePay {
          font-size: 14px;
          font-weight: 500;
          margin-left: 5px;
        }
      }

      .delayTime {
        position: absolute;
        text-wrap: wrap;
        width: 200px;
        left: -80px;
        bottom: 20px;
        font-size: 12px;
        line-height: 16px;
        color: #999;
        font-weight: 500;
      }
    }
  }

  .contactCust {
    font-size: 14px;
    color: #999;
    font-weight: 500;
    margin-top: 12px;
    margin-left: 31px;

    a {
      color: #e67030;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .code {
    position: absolute;
    top: 450px;
    left: 100px;
    background-color: rgba(0, 0, 0, .5);
    padding: 5px;
    border-radius: 10px;

    &:last-child {
      margin-right: 0;
    }

    img {
      display: block;
      width: 70px;
      margin: 0 auto;
      padding-top: 6px;
    }

    p {
      font-size: 14px;
      color: #fff;
      padding: 6px 7px;
      text-align: center;
      white-space: nowrap;
    }
  }

  .cancel {
    width: 35px;
    height: 35px;
    background-color: rgba(0, 0, 0, .8);
    color: #fff;
    font-size: 24px;
    text-align: center;
    line-height: 32px;
    border-radius: 50%;
    position: absolute;
    top: -20px;
    right: -34px;
    z-index: 1000;
    cursor: pointer;
  }
}
</style>